import type { AccountInfo } from '@azure/msal-browser'

/**
 * Which cached MSAL account a token is acquired for — the one rule every token path in the web-app
 * uses (#8265; see appian-migration/_knowledge-base/react-conventions.md §41).
 *
 * The active account is the one the user last signed in with, but it lives in shared localStorage,
 * so another tab's sign-in can name an account this tab does not hold. It is honoured only when it
 * is one of `accounts`; otherwise the oldest cached account is used, as before the active account
 * was consulted at all.
 */
export function isTabAccount(account: AccountInfo | null | undefined, accounts: AccountInfo[]): account is AccountInfo {
  return account != null && accounts.some(cached => cached.homeAccountId === account.homeAccountId)
}

/**
 * The active account itself when it is one of `accounts` (not the first profile sharing its
 * homeAccountId: getAllAccounts lists one entry per tenant profile), else `accounts[0]`, else
 * undefined when nothing is cached.
 */
export function resolveTabAccount(active: AccountInfo | null, accounts: AccountInfo[]): AccountInfo | undefined {
  return isTabAccount(active, accounts) ? active : accounts[0]
}
